import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"text-align":"center"},
  "element-loading-text": "正在提交数据，请稍后"
}
const _hoisted_2 = { style: {"text-align":"left"} }
const _hoisted_3 = { style: {"padding-top":"20px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("选择")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")

import { ref, reactive, unref } from 'vue';
import { useRouter } from 'vue-router';

/* Npm Plugins */
import { ElButton, ElTag } from 'element-plus';
import { Search } from '@element-plus/icons-vue'

/* Plugins */
import { GbTables } from "@/components/GbTables"
import { GbDialog } from '@/components/GbDialog/Index';

/* 辅助函数 & hooks */
import { GetPartType } from '../../../helpers/statusHelpers';
import { useGbTable } from '@/hooks/useGbTable'

/* API */
import { GetCpListApi } from '@/apis/counterpart/counterpart.api';

/* types */
import type { TableColumn } from '@/components/GbTables/GbTablesTypes'
import type { CounterpartSearch, CounterpartList } from '@/apis/counterpart/counterpart.type'


export default /*#__PURE__*/_defineComponent({
  emits: ["onSelect"],
  setup(__props, { expose, emit }) {

const { push } = useRouter()

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<CounterpartList>({
    getListApi: GetCpListApi,
    response: {
        data: 'data',
        total: 'total'
    }
})

const { setSearchParams } = methods

/* 控制变量 */
const search = reactive<CounterpartSearch>({
    current: 1,
    page_size: 10,
    tenant_id: '1',
    is_enabled: 'Y',
    part_type_id: ''
})

const showDialog = ref<boolean>(false)

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
    { field: 'name', label: '名称', columnWidth: "180" },
    { field: 'part_type_id', label: '客户类型', columnWidth: "100", },
    { field: 'contract', label: '联系人', columnWidth: "80" },
    { field: 'contract_num', label: '联系人电话', columnWidth: "100" },
    { field: 'address', label: '地址', align: "left" },
    { field: 'action', width: '80px', label: "操作", fixed: 'left', align: 'center' },

])

/* el-tag样式转换 */
const getElType = (partTypeID: string): any => { return GetPartType(partTypeID).color }

/* 点击选择按钮 */
const onSelect = (row: any) => {

    emit('onSelect', row)

}

/* 暴露出去的属性&方法 */
const pubMethods: {
    showCpDialog: () => void,
    closeCpDialog: () => void,

} = {

    showCpDialog: () => {

        unref(search).part_type_id = ''
        unref(search).name = ''

        showDialog.value = true

        setSearchParams(search)

    },

    closeCpDialog: () => {

        showDialog.value = false

    }

}

expose({ pubMethods })



return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showDialog).value = $event)),
    title: "相对方选择"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(ElButton), {
        type: "info",
        disabled: _unref(tableObject).loading,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_input, {
            modelValue: _unref(search).name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(search).name) = $event)),
            placeholder: "请输入相对方编号或名称",
            class: "input-with-select"
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _unref(search).part_type_id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(search).part_type_id) = $event)),
                placeholder: "相对方类型",
                style: {"width":"115px"},
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "内部单位",
                    value: "1"
                  }),
                  _createVNode(_component_el_option, {
                    label: "供应商",
                    value: "2"
                  }),
                  _createVNode(_component_el_option, {
                    label: "客户",
                    value: "3"
                  }),
                  _createVNode(_component_el_option, {
                    label: "合作伙伴",
                    value: "4"
                  }),
                  _createVNode(_component_el_option, {
                    label: "其他",
                    value: "99"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            append: _withCtx(() => [
              _createVNode(_unref(ElButton), {
                icon: _unref(Search),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(GbTables), {
            pageSize: _unref(tableObject).pageSize,
            "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
            currentPage: _unref(tableObject).currentPage,
            "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
            selection: false,
            columns: _unref(tabColumns),
            data: _unref(tableObject).tableList,
            loading: _unref(tableObject).loading,
            pagination: { total: _unref(tableObject).total },
            onRegister: _unref(register)
          }, {
            part_type_id: _withCtx(({ row }) => [
              _createVNode(_unref(ElTag), {
                effect: "light",
                type: getElType(row.part_type_id)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(GetPartType)(row.part_type_id).text), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            action: _withCtx(({ row }) => [
              _createVNode(_unref(ElButton), {
                type: "primary",
                link: "",
                onClick: ($event: any) => (onSelect(row))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
        ])
      ])), [
        [_directive_loading, _unref(tableObject).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})